var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"post-job-link"},[_c('hr'),_vm._v("\n  "+_vm._s(_vm.$t('tasks.areYouEmployer'))+"\n  "),_c('post-job-menu-item',{staticClass:"ml-1"},[_c('u',[_vm._v(_vm._s(_vm.$t('tasks.postSimilarJob')))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }